import { IRoleRepository, Role } from '../domain/IRoleRepository'
import { trackingAxios } from '../../config/api/tracking'

interface RoleApiResponse {
    error: boolean
    message: string
    roles: Role[]
}

export class AxiosRoleRepository implements IRoleRepository {
    async getAll(): Promise<Role[]> {
        try {
            const response = await trackingAxios.get<RoleApiResponse>(
                '/roles/list'
            )

            const roles = Array.isArray(response.data.roles)
                ? response.data.roles
                : []
            return roles.map((role: Role) => ({
                id: role.id,
                name: role.name,
            }))
        } catch (error) {
            console.error('Error fetching roles:', error)
            throw error
        }
    }
}
